import type React from 'react';

export interface SessionMetaProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  variant?: 'date' | 'count' | 'status';
}

const variantClasses = {
  date: 'text-text-disabled',
  count: 'text-text-disabled',
  status: 'text-text-muted'
};

export default function SessionMeta({
  children,
  variant = 'date',
  className = '',
  ...props
}: SessionMetaProps) {
  return (
    <span
      className={`text-xs ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}